import React, { useState, useEffect } from "react"
import "./styles.scss"
import check from './../../../images/check-ico.svg'
import checkWhite from './../../../images/check-white-ico.svg'

export default props => {
    let [ error, setError ] = useState(false);

    useEffect(() => {
          if ( props.forceValidate ) {
              if ( props.required && !(props.val == props.text)) {
                  setError(true);
              }
              if ( props.required && (props.val == props.text )) {
                  setError(false)
              }
          } else {
            setError(false)
          }
    }, [props.forceValidate])

    useEffect(() => {
        if ( props.otherForceValidate ) {
            if(props.required && !props.val) {
                setError(true);
            }else{
                setError(false);
            }
        }
    }, [props.otherForceValidate])

    return (
        <div className={"checkbox " + ( error ? 'error error-item' : '' )}>
            <div className="check" onClick={ () => props.setFunction(props.text) }>
                { props.val == props.text && 
                    <>
                        { props.whiteCheck &&
                            <img src={ checkWhite } alt="Zaznaczony"/>
                        }
                        { !props.whiteCheck &&
                            <img src={ check } alt="Zaznaczony"/>
                        }
                   </>
                }
            </div>
            <div className="text">{ props.text }</div>
            { error && 
                <div className="error-message">
                    Required
                </div>
            }
        </div>
  )
}
